import { render, staticRenderFns } from "./VolcVoicePickerDialog.vue?vue&type=template&id=14993ea1&scoped=true&"
import script from "./VolcVoicePickerDialog.vue?vue&type=script&lang=js&"
export * from "./VolcVoicePickerDialog.vue?vue&type=script&lang=js&"
import style0 from "./VolcVoicePickerDialog.vue?vue&type=style&index=0&id=14993ea1&prod&lang=less&scoped=true&"
import style1 from "./VolcVoicePickerDialog.vue?vue&type=style&index=1&id=14993ea1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14993ea1",
  null
  
)

export default component.exports